export default function PageTransition({ children }) {
  return (
    <div
      style={{
        width: "100%",
        animation: "pageEnter 0.22s ease-out both",
      }}
    >
      {children}
    </div>
  );
}